//Interface for viewing/editing a list of IP addresses known to belong to bots
import React from 'react';
import { Controls, CreateNew, Display } from './BotManagement';

function BotManagementPage() {
	//Random ID generated for new IP addresses. Current Datastore system seems
	//to be predicated on the idea that every item will start with a unique id.
	//Not the case for these IPs; needed something to use as an id.
	const idPath = ['widget', 'BotManagementPage', 'id'];

	return (
		<div className="BotManagementPage">
			<Display />
			<CreateNew idPath={idPath} />
			<Controls idPath={idPath} />
		</div>
	);
}

export default BotManagementPage;
